/**
 * @generated SignedSource<<5ed1049825fa663fd740f39e6502b798>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RatecardProjectSupplements = "EXCLUDED" | "INCLUDED" | "NOT_APPLICABLE" | "%future added value";
export type RatecardProjectVat = "EXCLUDED" | "INCLUDED" | "NOT_APPLICABLE" | "%future added value";
export type RatecardProjectProviderRatecardProjectQuery$variables = {
  id: string;
};
export type RatecardProjectProviderRatecardProjectQuery$data = {
  readonly ratecardProject: {
    readonly announcementSetId: string | null;
    readonly editMode: boolean;
    readonly id: string;
    readonly internalDocumentSetId: string | null;
    readonly isCurrentUserAdmin: boolean | null;
    readonly isCurrentUserReadonly: boolean | null;
    readonly isRfi: boolean | null;
    readonly members: ReadonlyArray<{
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null> | null;
    readonly noRatecardsCreated: boolean | null;
    readonly onHold: boolean;
    readonly projectName: string | null;
    readonly projectTimezone: string | null;
    readonly proposals: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly company: {
            readonly companyName: string;
            readonly id: string;
            readonly logo: string | null;
          };
          readonly id: string;
          readonly state: string;
        } | null;
      } | null>;
    };
    readonly questionSetId: string | null;
    readonly rates: string | null;
    readonly referenceCurrency: {
      readonly id: string;
      readonly isoCurrencyCode: string;
    } | null;
    readonly selectiveBids: boolean;
    readonly state: string;
    readonly supplements: RatecardProjectSupplements | null;
    readonly vat: RatecardProjectVat | null;
    readonly " $fragmentSpreads": FragmentRefs<"OtherInformation_ratecardProject" | "OverviewRatecardSummary_ratecardProject" | "RatecardProjectEditModeSidebar_ratecardProject" | "RatecardProjectSidebar_ratecardProject" | "RatecardProjectStepper_ratecardProject" | "SupplierSelection_ratecardProject" | "TenderPlanning_ratecardProject">;
  } | null;
};
export type RatecardProjectProviderRatecardProjectQuery = {
  response: RatecardProjectProviderRatecardProjectQuery$data;
  variables: RatecardProjectProviderRatecardProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRfi",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "announcementSetId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "questionSetId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalDocumentSetId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectTimezone",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurrentUserAdmin",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurrentUserReadonly",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoCurrencyCode",
  "storageKey": null
},
v13 = [
  (v2/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noRatecardsCreated",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editMode",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectiveBids",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rates",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supplements",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vat",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "RatecardProposalNodeConnection",
  "kind": "LinkedField",
  "name": "proposals",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RatecardProposalNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RatecardProposalNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyNode",
              "kind": "LinkedField",
              "name": "company",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v21/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "logo",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onHold",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RatecardProjectProviderRatecardProjectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RatecardProjectNode",
        "kind": "LinkedField",
        "name": "ratecardProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyNode",
            "kind": "LinkedField",
            "name": "referenceCurrency",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RatecardProjectSidebar_ratecardProject"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RatecardProjectEditModeSidebar_ratecardProject"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RatecardProjectStepper_ratecardProject"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TenderPlanning_ratecardProject"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SupplierSelection_ratecardProject"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OtherInformation_ratecardProject"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OverviewRatecardSummary_ratecardProject"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RatecardProjectProviderRatecardProjectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RatecardProjectNode",
        "kind": "LinkedField",
        "name": "ratecardProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyNode",
            "kind": "LinkedField",
            "name": "referenceCurrency",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoCurrencyName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RatecardProjectValidationNode",
            "kind": "LinkedField",
            "name": "validation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tenderPlanning",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supplierSelection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ratecard",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allSuccessful",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "errorMessage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mandayEstimate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validityMonths",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RevenueRangeNode",
            "kind": "LinkedField",
            "name": "companySizeRevenue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueRange",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeesRangeNode",
            "kind": "LinkedField",
            "name": "companySizeEmployees",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employeesRange",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "useDefaultCompany",
            "storageKey": null
          },
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyWebsite",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyAddressLineOne",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyAddressLineTwo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyAddressLineThree",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "volumeEstimate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyNode",
            "kind": "LinkedField",
            "name": "budgetEstimateCurrency",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "budgetApprovalStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showBudgetFieldsToSupplier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyPostalCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyCity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryNode",
            "kind": "LinkedField",
            "name": "companyCountry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iso2letter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commonNameEn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commonNameDe",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TimelineEventNodeConnection",
            "kind": "LinkedField",
            "name": "timelineEvents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TimelineEventNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimelineEventNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hardLimit",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceStandardNode",
            "kind": "LinkedField",
            "name": "serviceStandard",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceEn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceDe",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IndustryStandardNode",
            "kind": "LinkedField",
            "name": "industryStandard",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "industryEn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "industryDe",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RatecardProjectConsultingCompanyNodeConnection",
            "kind": "LinkedField",
            "name": "consultingCompanies",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RatecardProjectConsultingCompanyNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RatecardProjectConsultingCompanyNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyNode",
                        "kind": "LinkedField",
                        "name": "company",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyNameAlias",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "alternateNames",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GeneralInfoNode",
                            "kind": "LinkedField",
                            "name": "generalInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "website",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactFirstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactLastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactEmail",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactPhone",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "additionalInformation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RatecardProjectFileNodeConnection",
            "kind": "LinkedField",
            "name": "projectAttachments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RatecardProjectFileNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RatecardProjectFileNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fileName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fileUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "933cae72e9aa9885392d607ec2a8f1b0",
    "id": null,
    "metadata": {},
    "name": "RatecardProjectProviderRatecardProjectQuery",
    "operationKind": "query",
    "text": "query RatecardProjectProviderRatecardProjectQuery(\n  $id: ID!\n) {\n  ratecardProject(id: $id) {\n    id\n    isRfi\n    announcementSetId\n    questionSetId\n    internalDocumentSetId\n    state\n    projectName\n    projectTimezone\n    isCurrentUserAdmin\n    isCurrentUserReadonly\n    referenceCurrency {\n      id\n      isoCurrencyCode\n    }\n    members {\n      id\n      email\n      firstName\n      lastName\n    }\n    noRatecardsCreated\n    editMode\n    selectiveBids\n    rates\n    supplements\n    vat\n    proposals {\n      edges {\n        node {\n          id\n          state\n          company {\n            id\n            companyName\n            logo\n          }\n        }\n      }\n    }\n    onHold\n    ...RatecardProjectSidebar_ratecardProject\n    ...RatecardProjectEditModeSidebar_ratecardProject\n    ...RatecardProjectStepper_ratecardProject\n    ...TenderPlanning_ratecardProject\n    ...SupplierSelection_ratecardProject\n    ...OtherInformation_ratecardProject\n    ...OverviewRatecardSummary_ratecardProject\n  }\n}\n\nfragment OtherInformation_ratecardProject on RatecardProjectNode {\n  id\n  additionalInformation\n  projectAttachments {\n    edges {\n      node {\n        id\n        fileName\n        fileUrl\n      }\n    }\n  }\n}\n\nfragment OverviewRatecardSummary_ratecardProject on RatecardProjectNode {\n  id\n  announcementSetId\n  state\n  isCurrentUserAdmin\n  editMode\n  projectName\n  projectTimezone\n  startDate\n  openEnd\n  validityMonths\n  volumeEstimate\n  referenceCurrency {\n    isoCurrencyName\n    isoCurrencyCode\n    id\n  }\n  mandayEstimate\n  industryStandard {\n    industryEn\n    industryDe\n    id\n  }\n  companyName\n  companyWebsite\n  companyAddressLineOne\n  companyAddressLineTwo\n  companyAddressLineThree\n  companyPostalCode\n  companyCity\n  companyCountry {\n    commonNameEn\n    commonNameDe\n    id\n  }\n  companySizeRevenue {\n    revenueRange\n    id\n  }\n  companySizeEmployees {\n    employeesRange\n    id\n  }\n  serviceStandard {\n    serviceEn\n    serviceDe\n    id\n  }\n  additionalInformation\n  projectAttachments {\n    edges {\n      node {\n        id\n        fileName\n        fileUrl\n      }\n    }\n  }\n  timelineEvents {\n    edges {\n      node {\n        id\n        name\n        date\n        description\n        eventType\n        hardLimit\n      }\n    }\n  }\n}\n\nfragment RatecardProjectEditModeSidebar_ratecardProject on RatecardProjectNode {\n  id\n  projectName\n  editMode\n  isCurrentUserAdmin\n  validation {\n    tenderPlanning\n    supplierSelection\n    ratecard\n    otherInformation\n    allSuccessful\n    errorMessage\n  }\n}\n\nfragment RatecardProjectSidebar_ratecardProject on RatecardProjectNode {\n  id\n  projectName\n  editMode\n  validation {\n    tenderPlanning\n    supplierSelection\n    ratecard\n    otherInformation\n    allSuccessful\n    errorMessage\n  }\n}\n\nfragment RatecardProjectStepper_ratecardProject on RatecardProjectNode {\n  id\n  projectName\n  editMode\n  validation {\n    tenderPlanning\n    supplierSelection\n    ratecard\n    otherInformation\n    allSuccessful\n    errorMessage\n  }\n}\n\nfragment SupplierSelection_ratecardProject on RatecardProjectNode {\n  id\n  serviceStandard {\n    id\n    serviceEn\n    serviceDe\n  }\n  industryStandard {\n    id\n    industryEn\n    industryDe\n  }\n  consultingCompanies {\n    edges {\n      node {\n        company {\n          id\n          companyName\n          companyNameAlias\n          alternateNames\n          generalInfo {\n            website\n            id\n          }\n        }\n        contactFirstName\n        contactLastName\n        contactEmail\n        contactPhone\n        id\n      }\n    }\n  }\n}\n\nfragment TenderPlanning_ratecardProject on RatecardProjectNode {\n  id\n  projectName\n  projectTimezone\n  referenceCurrency {\n    id\n    isoCurrencyCode\n  }\n  startDate\n  mandayEstimate\n  validityMonths\n  openEnd\n  companySizeRevenue {\n    id\n    revenueRange\n  }\n  companySizeEmployees {\n    id\n    employeesRange\n  }\n  useDefaultCompany\n  companyName\n  companyWebsite\n  companyAddressLineOne\n  companyAddressLineTwo\n  companyAddressLineThree\n  volumeEstimate\n  budgetEstimateCurrency {\n    id\n    isoCurrencyCode\n  }\n  budgetApprovalStatus\n  showBudgetFieldsToSupplier\n  companyPostalCode\n  companyCity\n  companyCountry {\n    id\n    iso2letter\n    commonNameEn\n    commonNameDe\n  }\n  timelineEvents {\n    edges {\n      node {\n        id\n        name\n        date\n        description\n        eventType\n        hardLimit\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fcc16ee4cad2a13efd1e21baea21b94";

export default node;
